module.exports = __webpack_public_path__ + "assets/ic_bookmark_pin.088d7a4f.svg";